import { Form } from "antd";
import { OptList } from "./Model";
import { TitleBar } from "./Model";
const SortList = (props) => {
  const handleCheck = (item) => {
    const { value = [], onChange } = props;
    const _value = [...value];
    let index = _value.findIndex((o) => o.position.toString() === item.position.toString());
    let checked = true;
    if (index >= 0) {
      _value.splice(index, 1);
      checked = !value[index].checked;
    }
    let insertIndex = _value.filter((o) => o.checked).length;
    _value.splice(insertIndex, 0, {
      answerId: item.id,
      position: item.position,
      checked,
      text: item.text,
      source: item,
    });
    onChange(_value);
  };
  return <OptList {...props} type="sort" onCheck={handleCheck}></OptList>;
};

const SortViews = (props) => {
  const { info } = props;
  return (
    <div className="components-input-views">
      <TitleBar info={info}></TitleBar>
      <div className="opt-list radio-list">
        <Form.Item name={["postAnswer", info.position]}>
          <SortList list={info.answerList}></SortList>
        </Form.Item>
      </div>
    </div>
  );
};

export default SortViews;
